import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { AuthConfigNaming } from '@models/auth-config';
import { IncomingHistoryNaming } from '@models/incoming-histories';
import { IntegrationConfigNaming } from '@models/integration-config';
import { JobRunNaming } from '@models/job-run';
import { MappingTemplateNaming } from '@models/mapping-templates';
import { OutgoingHistoryNaming } from '@models/outgoing-histories';
import { TemplateNaming } from '@models/templates';
import { WorkflowNaming } from '@models/workflow';
import { IrtWorkflowRunNaming } from '@models/workflow-run';
import { OutboundConfigNaming } from '../../models/outbound-config';

export type TFieldNames<T = any> = Record<keyof T, string>;
export type PluralMap = { '=1': string; other: string } & { [count: string]: string };

export const DEFAULT_NAMING_KEY = new InjectionToken<string>('Default Naming Key');
export const MODEL_NAME_TITLE = new InjectionToken<Record<string, PluralMap>[]>('MODEL_NAME_TITLE');
export const MODEL_NAME_LOWER = new InjectionToken<Record<string, PluralMap>[]>('MODEL_NAME_LOWER');
export const FIELD_NAMES = new InjectionToken<Record<string, TFieldNames>[]>('FIELD_NAMES');

export type NamingConfigInput<TModel> = {
  fieldNames: TFieldNames<TModel>;
  modelName: PluralMap | [PluralMap, PluralMap?];
  key: string;
};
export const ModelNameTitle = new InjectionToken<Record<string, PluralMap>>(
  'ModelName title-case maps'
);
export const ModelNameLower = new InjectionToken<Record<string, PluralMap>>(
  'ModelName lowercase maps'
);
export const FieldNames = new InjectionToken<Record<string, TFieldNames>>('Field name maps');

@NgModule({
  providers: [
    {
      provide: ModelNameTitle,
      useFactory: (titleMaps: Record<string, PluralMap>[]) => Object.assign({}, ...titleMaps),
      deps: [MODEL_NAME_TITLE],
    },
    {
      provide: ModelNameLower,
      useFactory: (lowerMaps: Record<string, PluralMap>[]) => Object.assign({}, ...lowerMaps),
      deps: [MODEL_NAME_LOWER],
    },
    {
      provide: FieldNames,
      useFactory: (fields: Record<string, TFieldNames>[]) => Object.assign({}, ...fields),
      deps: [FIELD_NAMES],
    },
  ],
})
export class NamingModule {
  static forRoot(): ModuleWithProviders<NamingModule> {
    return {
      ngModule: NamingModule,
      providers: [
        OutboundConfigNaming.forRoot(),
        TemplateNaming.forRoot(),
        WorkflowNaming.forRoot(),
        IrtWorkflowRunNaming.forRoot(),
        MappingTemplateNaming.forRoot(),
        IntegrationConfigNaming.forRoot(),
        AuthConfigNaming.forRoot(),
        JobRunNaming.forRoot(),
        OutgoingHistoryNaming.forRoot(),
        IncomingHistoryNaming.forRoot(),
      ],
    };
  }
}
